import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

class BusyIndicatorService {
    constructor() {
        this.subject = new Subject();
    }
    show(option = true) {
        this.subject.next(option);
    }
    hide() {
        this.show(false);
    }
    subscription() {
        return this.subject.asObservable();
    }
}
BusyIndicatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BusyIndicatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class BusyIndicatorComponent {
    constructor(biService) {
        this.biService = biService;
        this.biService.subscription().subscribe(option => this.showing = option);
    }
    ngOnInit() {
    }
}
BusyIndicatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorComponent, deps: [{ token: BusyIndicatorService }], target: i0.ɵɵFactoryTarget.Component });
BusyIndicatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.0", type: BusyIndicatorComponent, selector: "busy-indicator", inputs: { showing: "showing", label: "label" }, ngImport: i0, template: "<div *ngIf=\"showing\" class=\"dimmed-and-centered\">\n    <div class=\"d-flex flex-column align-items-center\">\n        <div *ngIf=\"label\" class=\"spinner-text mb-3\"> {{ label }} </div>\n        <div class=\"spinner-border bigger-spinner\"></div>\n    </div>\n</div>\n", styles: [".dimmed-and-centered{z-index:10;position:absolute;top:0;height:100%;width:100%;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4)}.bigger-spinner{width:4rem;height:4rem}.spinner-text{font-weight:bolder;font-size:large}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'busy-indicator', template: "<div *ngIf=\"showing\" class=\"dimmed-and-centered\">\n    <div class=\"d-flex flex-column align-items-center\">\n        <div *ngIf=\"label\" class=\"spinner-text mb-3\"> {{ label }} </div>\n        <div class=\"spinner-border bigger-spinner\"></div>\n    </div>\n</div>\n", styles: [".dimmed-and-centered{z-index:10;position:absolute;top:0;height:100%;width:100%;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4)}.bigger-spinner{width:4rem;height:4rem}.spinner-text{font-weight:bolder;font-size:large}\n"] }]
        }], ctorParameters: function () { return [{ type: BusyIndicatorService }]; }, propDecorators: { showing: [{
                type: Input
            }], label: [{
                type: Input
            }] } });

class BusyIndicatorModule {
}
BusyIndicatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BusyIndicatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorModule, declarations: [BusyIndicatorComponent], imports: [BrowserModule,
        CommonModule], exports: [BusyIndicatorComponent] });
BusyIndicatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorModule, imports: [[
            BrowserModule,
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: BusyIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BusyIndicatorComponent
                    ],
                    imports: [
                        BrowserModule,
                        CommonModule
                    ],
                    exports: [
                        BusyIndicatorComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of busy-indicator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BusyIndicatorComponent, BusyIndicatorModule, BusyIndicatorService };
